import axios from "axios";
import { MYDTAS_API } from "../../../config/globalVariables";

export const mydtasClient = axios.create({
  baseURL: (MYDTAS_API || "").replace(/\/$/, ""),
  timeout: 30000,
});

// Request interceptor — JWT Bearer token + Accept-Language
mydtasClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    const lang = localStorage.getItem("i18nextLng") || "tr";
    config.headers["Accept-Language"] = lang;
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor — 401 redirect
mydtasClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("jwtToken");
      localStorage.removeItem("aadToken");
      window.location.href = "/";
      return Promise.reject(new Error("Unauthorized"));
    }
    return Promise.reject(error);
  },
);
